import React from "react";

const VistaCobroAlumno = ({
  catalogoConceptos,
  carrito,
  agregarAlCarrito,
  quitarDelCarrito,
  totalCarrito,
  procesarPagoCaja,
  generarFichaPdf,
  loading,
  modalExito,    //  NUEVA PROP recibida desde el Hook
  setModalExito, //  NUEVA PROP para cerrar la ventana
  puedeCobrar = true
}) => {
  return (
    <div className="cobro-layout">
      {/* Lado Izquierdo: Catálogo de Conceptos a 2 Columnas */}
      <div className="catalogo-section">
        <div className="catalogo-header">
          <h3>Conceptos Generales</h3>
          <p>Selecciona los conceptos a cobrar de la siguiente lista.</p>
        </div>

        <div className="conceptos-grid-2col">
          {[...catalogoConceptos]
            .sort((a, b) => a.concepto.localeCompare(b.concepto))
            .map((concepto) => (
              <div key={concepto.id} className="concepto-fila">
                <div className="concepto-detalle">
                  <span className="concepto-nombre">{concepto.concepto}</span>
                </div>
                <div className="concepto-accion">
                  <span className="concepto-costo">${Number(concepto.precio).toFixed(2)}</span>
                  <button
                    className="btn-add-small"
                    onClick={() => agregarAlCarrito(concepto)}
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* Lado Derecho: Ticket de Cobro Fijo */}
      <div className="ticket-section">
        <div className="ticket-card">
          <h3 className="ticket-title">Ticket de Cobro</h3>

          <div className="ticket-items-container">
            {carrito.length === 0 ? (
              <p className="ticket-vacio">El carrito está vacío.</p>
            ) : (
              carrito.map((item) => (
                <div key={item.id} className="ticket-item">
                  <span className="item-nombre">{item.concepto}</span>
                  <div className="item-controles">
                    <span className="item-cantidad" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <button
                        onClick={() => quitarDelCarrito(item.id)}
                        style={{ cursor: 'pointer', padding: '0 6px', border: '1px solid #ccc', borderRadius: '4px', background: '#fff' }}
                      >
                        -
                      </button>
                      Cant: {item.cantidad}
                      <button
                        onClick={() => agregarAlCarrito(item)}
                        style={{ cursor: 'pointer', padding: '0 6px', border: '1px solid #ccc', borderRadius: '4px', background: '#fff' }}
                      >
                        +
                      </button>
                    </span>

                    <span className="item-subtotal">${Number(item.precio * item.cantidad).toFixed(2)}</span>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="ticket-footer">
            <div className="ticket-total">
              <span>Total:</span>
              <span className="total-monto">${Number(totalCarrito).toFixed(2)}</span>
            </div>
            
            {puedeCobrar && (
              <button
                className="btn-pagar-grande"
                disabled={carrito.length === 0 || loading}
                onClick={procesarPagoCaja}
              >
                {loading ? "Procesando..." : "Confirmar Cobro"}
              </button>
            )}

            {carrito.length > 0 && carrito.every((item) => item.permite_pdf) && (
              <button
                className="btn-pagar-grande btn-pagar-verde"
                style={{ marginTop: '10px' }}
                disabled={loading}
                onClick={generarFichaPdf}
              >
                📄 Generar ficha PDF
              </button>
            )}
          </div>

        </div>
      </div>

      {/* ========================================================= */}
      {/*  NUEVO: VENTANA EMERGENTE OBLIGATORIA (MODAL DE ÉXITO)  */}
      {/* ========================================================= */}
      {modalExito?.visible && (
        <div className="modal-overlay-exito">
          <div className="modal-card-exito">
            <div className="modal-icon-exito">🎉</div>
            <h2 className="modal-title-exito">¡Cobro Registrado con Éxito!</h2>
            <p className="modal-subtitle-exito">La transacción fue aprobada y guardada de manera correcta.</p>
            
            <div className="modal-detalles-exito">
              {modalExito.nombreAlumno && (
                <div className="detalle-row-exito">
                  <span>Alumno:</span>
                  <strong>{modalExito.nombreAlumno}</strong>
                </div>
              )}
              <div className="detalle-row-exito">
                <span>Monto Cobrado:</span>
                <strong className="monto-resaltado-exito">${Number(modalExito.monto).toFixed(2)} MXN</strong>
              </div>
              <div className="detalle-row-exito">
                <span>No. Autorización:</span>
                <strong className="codigo-exito">{modalExito.autorizacion}</strong>
              </div>
              <div className="detalle-row-exito">
                <span>Línea de Captura:</span>
                <strong className="codigo-exito">{modalExito.referencia}</strong>
              </div>
            </div>

            {/* ============================================================= */}
            {/* VOUCHER: datos obligatorios segun el Anexo VII de Banorte     */}
            {/* (Generacion de vouchers) para la certificacion.               */}
            {/* ============================================================= */}
            <h3 className="modal-title-exito" style={{ fontSize: "1rem", marginTop: "18px" }}>
              Comprobante de la transacción
            </h3>
            <div className="modal-detalles-exito">
              {modalExito.entidad && (
                <div className="detalle-row-exito">
                  <span>Entidad financiera:</span>
                  <strong>{modalExito.entidad}</strong>
                </div>
              )}
              <div className="detalle-row-exito">
                <span>Tipo de operación:</span>
                <strong>Venta</strong>
              </div>
              {modalExito.nombreComercio && (
                <div className="detalle-row-exito">
                  <span>Comercio:</span>
                  <strong>{modalExito.nombreComercio}</strong>
                </div>
              )}
              {modalExito.direccion && (
                <div className="detalle-row-exito">
                  <span>Dirección:</span>
                  <strong>{modalExito.direccion}</strong>
                </div>
              )}
              {modalExito.telefono && (
                <div className="detalle-row-exito">
                  <span>Teléfono:</span>
                  <strong>{modalExito.telefono}</strong>
                </div>
              )}
              {modalExito.afiliacion && (
                <div className="detalle-row-exito">
                  <span>Afiliación:</span>
                  <strong className="codigo-exito">{modalExito.afiliacion}</strong>
                </div>
              )}
              {modalExito.terminalId && (
                <div className="detalle-row-exito">
                  <span>Terminal ID:</span>
                  <strong className="codigo-exito">{modalExito.terminalId}</strong>
                </div>
              )}
              {modalExito.numeroControl && (
                <div className="detalle-row-exito">
                  <span>Número de control:</span>
                  <strong className="codigo-exito">{modalExito.numeroControl}</strong>
                </div>
              )}
              {modalExito.referenciaPayworks && (
                <div className="detalle-row-exito">
                  <span>Referencia:</span>
                  <strong className="codigo-exito">{modalExito.referenciaPayworks}</strong>
                </div>
              )}
              {modalExito.tarjeta && (
                <div className="detalle-row-exito">
                  <span>Número de tarjeta:</span>
                  <strong className="codigo-exito">{modalExito.tarjeta}</strong>
                </div>
              )}
              {modalExito.vigenciaTarjeta && (
                <div className="detalle-row-exito">
                  <span>Vigencia:</span>
                  <strong className="codigo-exito">{modalExito.vigenciaTarjeta}</strong>
                </div>
              )}
              {(modalExito.marcaTarjeta || modalExito.tipoTarjeta) && (
                <div className="detalle-row-exito">
                  <span>Tipo de tarjeta:</span>
                  <strong>{[modalExito.marcaTarjeta, modalExito.tipoTarjeta].filter(Boolean).join(" — ")}</strong>
                </div>
              )}
              {modalExito.bancoEmisor && (
                <div className="detalle-row-exito">
                  <span>Banco emisor:</span>
                  <strong>{modalExito.bancoEmisor}</strong>
                </div>
              )}
              {modalExito.modoEntrada && (
                <div className="detalle-row-exito">
                  <span>Modo de entrada:</span>
                  <strong>{modalExito.modoEntrada}</strong>
                </div>
              )}
              <div className="detalle-row-exito">
                <span>Validación:</span>
                <strong>
                  {modalExito.validacionPin === "1"
                    ? "PIN verificado"
                    : modalExito.validacionPin === "2"
                    ? "QPS — Autorizado sin firma"
                    : "Autorizado con firma electrónica"}
                </strong>
              </div>
              {modalExito.fechaPayworks && (
                <div className="detalle-row-exito">
                  <span>Fecha y hora:</span>
                  <strong>{modalExito.fechaPayworks}</strong>
                </div>
              )}
              {/* Tags EMV: solo vienen cuando la tarjeta se leyo por chip */}
              {modalExito.aid && (
                <div className="detalle-row-exito">
                  <span>AID:</span>
                  <strong className="codigo-exito">{modalExito.aid}</strong>
                </div>
              )}
              {modalExito.tvr && (
                <div className="detalle-row-exito">
                  <span>TVR:</span>
                  <strong className="codigo-exito">{modalExito.tvr}</strong>
                </div>
              )}
              {(modalExito.appPrefName || modalExito.appLabel) && (
                <div className="detalle-row-exito">
                  <span>Aplicación:</span>
                  <strong>{modalExito.appPrefName || modalExito.appLabel}</strong>
                </div>
              )}
            </div>

            <button 
              className="btn-modal-aceptar-exito"
              onClick={() => setModalExito({ ...modalExito, visible: false })}
            >
              Aceptar y Continuar
            </button>
          </div>
        </div>
      )}
      {/* ========================================================= */}
    </div>
  );
};

export default VistaCobroAlumno;